import { useParams, Link } from 'react-router-dom';
import { studyBySlug } from './studies/index.js';
import StudyRunner from './StudyRunner.jsx';

export default function StudyPage() {
  const { slug } = useParams();
  const study = studyBySlug(slug);
  if (!study) {
    return (
      <div className="app">
        <div className="card center">
          <h1>Study not found</h1>
          <p className="muted">That study link doesn’t match any current study.</p>
          <Link className="btn btn--primary" to="/studies">Browse studies</Link>
        </div>
      </div>
    );
  }
  return <StudyRunner study={study} key={slug} />;
}
